


















import { Component, Prop, Mixins } from '$/lib/vueExt';
import VueValidationMixin          from '$/lib/mixins/VueValidationMixin';

import { Building } from '$/entities/Building';
import { EntityID } from '$/entities/BaseEntity';

import BuildingModal from '$/screens/App/Buildings/BuildingModal.vue';

@Component({
	components : { BuildingModal },
	model      : { prop : 'building', event : 'update:building' },
})
export default class BuildingSelector extends Mixins(VueValidationMixin) {

	@Prop({ default : null })
	readonly building: Building;

	@Prop({ default : false })
	readonly allowNew: boolean;

	localBuilding: Building = null;
	buildings: Building[]   = [];
	total                   = 0;

	get options() {
		return [
			this.allowNew ? { id : 'new', getName : () => 'New Property' } : '',
			...Building.sortBuildings(_.compact(_.uniqBy([ this.building, ...this.buildings ], 'id'))),
		];
	}

	formatter(building: string | Building) {
		if (building === '') {
			return 'All Properties';
		}
		if (building && typeof building !== 'string') {
			return building.getName();
		}
	}

	mounted() {
		void this.loadBuildings();
	}

	findBuilding(id: EntityID) {
		return this.buildings?.find(building => building.id === id);
	}

	async loadBuildings($search?) {
		const [ buildings, total ] = await Building.findAndCount({ where : { $search } });
		const search               = $search?.toLowerCase();
		const exactMatch           = buildings.find(building => _.isNotEmpty(search) && (search.includes(building.street.toLowerCase()) || search.includes(building.userName.toLowerCase())));
		this.buildings             = exactMatch ? [ exactMatch ] : buildings;
		this.total                 = exactMatch ? 1 : total;
	}

	handleValueUpdate(value: Building) {
		if (value?.id === 'new') {
			this.localBuilding = new Building();
			return;
		}

		this.$emit('update:building', value);
	}

	async onBuildingModalClosed() {
		if (this.localBuilding && !this.localBuilding.isNew) {
			await this.loadBuildings();
		}
		else {
			this.localBuilding = null;
		}
		this.$emit('update:building', this.localBuilding);
	}

}
